import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors, redirectToSignificantPeoplePage } from '../../infrastructure/config';
import ReviewSectionsPage from './ReviewSectionsPage';
import {
  dataCaptureSelectors,
  saveDetailsForm,
  saveBusinessMandateForm,
  updateReviewCase,
  redirectToBDDReviewScreen,
  onAccountDetailsChange,
  onCountryRemove,
  routeToImportantInfoPage
} from '../../store/dataCapture';
import { NAVIGATION_BACK, CASE_ID, MANDATE_INFO, APPLICANT_FLOW } from '../../utils/constants';
import { selectors as caseSelector } from '../../infrastructure/cases';
import { getQueryStringValueByName } from '../../utils';

class ReviewSections extends Component {
  constructor(props) {
    super(props);
    this.businessBack = this.businessBack.bind(this);
  }

  businessBack() {
    this.props.redirectToBDDReviewScreen(
      NAVIGATION_BACK,
      getQueryStringValueByName(APPLICANT_FLOW)
    );
  }

  render() {
    const {
      bankId,
      brandId,
      getBusinessData,
      getPaymentTypeCheckboxValue,
      saveDetailsForm,
      onCountryRemove,
      saveBusinessMandateForm,
      updateReviewCase,
      linkCode,
      businessMandatedata,
      caseType,
      routeToImportantInfoPage,
      redirectToSignificantPeoplePage
    } = this.props;

    return (
      <ReviewSectionsPage
        brandId={brandId}
        bankId={bankId}
        getBusinessData={getBusinessData}
        linkCode={linkCode}
        onAccountDetailsChange={onAccountDetailsChange}
        getPaymentTypeCheckboxValue={getPaymentTypeCheckboxValue}
        backClick={this.businessBack}
        onCountryRemove={onCountryRemove}
        saveDetailsForm={saveDetailsForm}
        routeToImportantInfoPage={routeToImportantInfoPage}
        redirectToSignificantPeoplePage={redirectToSignificantPeoplePage}
        caseType={caseType}
        saveBusinessMandateForm={saveBusinessMandateForm}
        businessMandatedata={businessMandatedata}
        updateReviewCase={updateReviewCase}
      />
    );
  }
}

ReviewSections.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId
};

const actionCreators = {
  saveDetailsForm,
  updateReviewCase,
  redirectToBDDReviewScreen,
  onAccountDetailsChange,
  onCountryRemove,
  saveBusinessMandateForm,
  routeToImportantInfoPage,
  redirectToSignificantPeoplePage
};

const mapStateToProps = state => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state),
  isSoleBusinessType: dataCaptureSelectors.isSoleBusinessType(state),
  getAccountDetails: dataCaptureSelectors.getAccountDetails(state),
  getBusinessData: dataCaptureSelectors.getAboutBusinessData(state),
  getPaymentTypeCheckboxValue: dataCaptureSelectors.getPaymentTypeCheckboxValue(state),
  linkCode: caseSelector.getJointLinkCode(state),
  caseId: selectors.getSingleEntry(state, CASE_ID),
  caseType: caseSelector.getCaseType(state),
  businessMandatedata: dataCaptureSelectors.getBusinessData(state, MANDATE_INFO)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ReviewSections);
